module.exports = __webpack_public_path__ + "static/aboutsandy-credential-fache-min-36ed747cfe93e79ea9e7aa59899483ea.png";